import React from 'react';

/**
 * EmptyCanvas component for GuiBuilder
 * Shows a message when the page canvas is empty
 */
export default function EmptyCanvas() {
    return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', color: 'var(--text-secondary)', padding: '4rem 0', gap: '1rem', textAlign: 'center' }}>
            <i className="fa-solid fa-pencil" style={{ fontSize: '2.5rem', opacity: 0.3 }}></i>
            <div>
                <h4 style={{ margin: 0, color: 'var(--text-primary)' }}>Empty Page Canvas</h4>
                <p style={{ fontSize: '0.8rem', margin: '0.25rem 0 0 0' }}>Insert headers, descriptions, and feature options from the left palette drawer to build the configuration UI.</p>
            </div>
        </div>
    );
}
